// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Root Theme Variables ── */
:root[data-theme='dark'] {
    --bg-main: #0b0f19;
    --bg-content: #111827;
    --text-primary: #f8fafc;
    --text-secondary: #94a3b8;
    --border-color: #1f2937;
    --card-bg: #161b22;
}

:root[data-theme='light'] {
    --bg-main: #f7f9fc;
    --bg-content: #f1f5f9;
    --text-primary: #1e293b;
    --text-secondary: #64748b;
    --border-color: #cbd5e1;
    --card-bg: #ffffff;
}

/* Global Reset */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

body {
  background-color: var(--bg-main, #f7f9fc);
  color: var(--text-primary, #333);
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Base Layout */
.dashboard-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.main-content {
  flex: 1 1;
  background-color: var(--bg-content, #f1f5f9);
  overflow-y: auto;
  padding: 20px;
  transition: all 0.3s ease;
}

/* Utilities */
a {
  text-decoration: none;
  color: inherit;
}

.flex { display: flex; }
.flex-1 { flex: 1 1; }
.p-4 { padding: 1rem; }
.min-h-screen { min-height: 100vh; }

/* Top Header Bar for Theme Icon */
.top-header-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 15px;
    width: 100%;
}

/* Minimalist Theme Icon Button */
.theme-icon-btn {
    background-color: var(--card-bg, #161b22);
    color: var(--text-primary, #ffffff);
    border: 1px solid var(--border-color, #30363d);
    width: 38px;
    height: 38px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.theme-icon-btn:hover {
    border-color: #58a6ff;
    transform: translateY(-1px);
}

/* Responsive tweaks for Mobile (Android/iOS) */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 250px;
    background: #2c3e50;
    color: white;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
  }

  .sidebar.visible {
    transform: translateX(0);
    box-shadow: 2px 0 10px rgba(0,0,0,0.3);
  }

  .main-content {
    margin-left: 0 !important;
    padding: 1rem;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,4DAA4D;AAC9D;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,4CAA4C;EAC5C,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,QAAQ,aAAa,EAAE;AACvB,UAAU,SAAO,EAAE;AACnB,OAAO,aAAa,EAAE;AACtB,gBAAgB,iBAAiB,EAAE;;AAEnC,kCAAkC;AAClC;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA,iCAAiC;AACjC;IACI,yCAAyC;IACzC,mCAAmC;IACnC,8CAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;EACb;AACF","sourcesContent":["/* ── Root Theme Variables ── */\n:root[data-theme='dark'] {\n    --bg-main: #0b0f19;\n    --bg-content: #111827;\n    --text-primary: #f8fafc;\n    --text-secondary: #94a3b8;\n    --border-color: #1f2937;\n    --card-bg: #161b22;\n}\n\n:root[data-theme='light'] {\n    --bg-main: #f7f9fc;\n    --bg-content: #f1f5f9;\n    --text-primary: #1e293b;\n    --text-secondary: #64748b;\n    --border-color: #cbd5e1;\n    --card-bg: #ffffff;\n}\n\n/* Global Reset */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\nbody {\n  background-color: var(--bg-main, #f7f9fc);\n  color: var(--text-primary, #333);\n  padding-top: env(safe-area-inset-top);\n  padding-bottom: env(safe-area-inset-bottom);\n  padding-left: env(safe-area-inset-left);\n  padding-right: env(safe-area-inset-right);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Base Layout */\n.dashboard-container {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n\n.main-content {\n  flex: 1;\n  background-color: var(--bg-content, #f1f5f9);\n  overflow-y: auto;\n  padding: 20px;\n  transition: all 0.3s ease;\n}\n\n/* Utilities */\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.flex { display: flex; }\n.flex-1 { flex: 1; }\n.p-4 { padding: 1rem; }\n.min-h-screen { min-height: 100vh; }\n\n/* Top Header Bar for Theme Icon */\n.top-header-bar {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-bottom: 15px;\n    width: 100%;\n}\n\n/* Minimalist Theme Icon Button */\n.theme-icon-btn {\n    background-color: var(--card-bg, #161b22);\n    color: var(--text-primary, #ffffff);\n    border: 1px solid var(--border-color, #30363d);\n    width: 38px;\n    height: 38px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.theme-icon-btn:hover {\n    border-color: #58a6ff;\n    transform: translateY(-1px);\n}\n\n/* Responsive tweaks for Mobile (Android/iOS) */\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 250px;\n    background: #2c3e50;\n    color: white;\n    z-index: 1000;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    -webkit-overflow-scrolling: touch;\n    overflow-y: auto;\n  }\n\n  .sidebar.visible {\n    transform: translateX(0);\n    box-shadow: 2px 0 10px rgba(0,0,0,0.3);\n  }\n\n  .main-content {\n    margin-left: 0 !important;\n    padding: 1rem;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
